import { Component, Input, OnInit } from '@angular/core';
import { OptionsTypeSelector } from '../../../../models/options-type-selector';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { BaryComponentHelper } from 'app/shared/util/bary-component-helper';
import { BaryTitleComponent } from '../bary-title/bary-title.component';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { NgForOf, NgIf } from '@angular/common';
import { TranslateDirective } from '../../../../directives/translate.directive';

@Component({
  selector: 'jhi-bary-options-selector',
  templateUrl: './bary-options-selector.component.html',
  styleUrls: ['./bary-options-selector.component.scss'],
  standalone: true,
  imports: [BaryTitleComponent, MDBBootstrapModulesPro, ReactiveFormsModule, NgIf, TranslateDirective, NgForOf],
})
export class BaryOptionsSelectorComponent implements OnInit {
  @Input() id = '';
  @Input() titleKey!: string;
  @Input() tooltip?: string;
  @Input() label: string | undefined;
  @Input() icon: string | undefined;
  @Input() options!: Array<OptionsTypeSelector>;

  @Input() control = new FormControl('');
  @Input() isLgIcon: boolean = false;
  @Input() heightCell: 'h-bary-sm' | 'h-bary-lg' | 'h-bary-xl' = 'h-bary-lg';
  @Input() widthCell: 'w-bary-sm' | 'w-bary-lg' | 'w-bary-xl' = 'w-bary-sm';
  @Input() justifyContent: 'justify-content-start' | 'justify-content-center' | 'justify-content-end' = 'justify-content-center';

  ngOnInit(): void {
    if (!this.id) {
      this.id = BaryComponentHelper.makeId();
    }
  }
}
